import React, { useState, useEffect } from "react";
import { AiFillEye, AiFillGithub } from "react-icons/ai";
import { motion } from "framer-motion";

import { AppWrap, MotionWrap } from "../../wrapper";
// import { urlFor, client } from "../../client";

import "./Work.scss";

const Work = () => {
	const [activeFilter, setActiveFilter] = useState("All");
	const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
	const [works, setWorks] = useState([]);
	const [filterWork, setFilterWork] = useState([]);

	useEffect(() => {
		// const query = '*[_type == "works"]';

		// client.fetch(query).then((data) => {
		// 	setWorks(data);
		// 	setFilterWork(data);
		// });
	}, []);

	const handleWorkFilter = (item) => {
		setActiveFilter(item);
		setAnimateCard([{ y: 100, opacity: 0 }]);

		setTimeout(() => {
			setAnimateCard({ y: 0, opacity: 1 });

			if (item === "All") {
				setFilterWork(works);
			} else {
				setFilterWork(works.filter((work) => work.tags.includes(`#${item}`)));
			}
		}, 500);
	};


	const workData = [
		// {
		// 	// name:'Admin Panel',
		// 	// description:'Admin panel created with React using Material UI and Recharts',
		// 	// imgSrc:'https://cdn.sanity.io/images/401mjdck/production/41c913ca45bfa3858451074312fe39941c1b3e1a-1331x625.png',
		// 	// hostLink:'https://adminpanel-reactapp.netlify.app/',
		// 	// repoLink:'https://github.com/jaffasunny/react-admin-panel',
		// },
		{
			name:'Ozean Nft Hub',
			description:'Ozean Nft Hub is Nft Market Place created with React using Material UI v5 Including Screens are Profile, Edit Profile, Dashboard, Nft Detail, Category Listing, maintenance, Error Page, etc',
			tag:'Project',
			imgSrc:'/work/ozeanNftHub.png',
			hostLink:'https://ozeannfthub.netlify.app/',
			repoLink:'https://github.com/KhaleequeurRehman/efmarketplace-project',
		},
		{
			name:'Coins Space',
			description:'Coins Space is Coingecko Inspired Template created with React using React Bootstrap Including Screens are Token, Miners, Dashboard, Nft, Contact us, etc',
			tag:'Project',
			imgSrc:'/work/coinsSpace.png',
			hostLink:'https://coinsspace.netlify.app/',
			repoLink:'https://github.com/KhaleequeurRehman/copyMockApp',
		},
		{
			name:'Exchange Dapp',
			description:'Exchange Dapp is PinkSale Inspired Template created with React using React Material UI v5 Including Screens are Home, Exchange, etc',
			tag:'Project',
			imgSrc:'/work/exchangeDapp.png',
			hostLink:'https://exchange-dapp.netlify.app/',
			repoLink:'https://github.com/KhaleequeurRehman',
		},
		{
			name:'Nextjs Dashboard',
			description:'Nextjs Dashboard is Nextjs Dashboard Template created with Nextjs 13 using  Tailwind css Including Screens are Home, Categories, etc',
			tag:'Project',
			imgSrc:'/work/nextjsDashboard.png',
			hostLink:'https://nextjs-dashboard-app-weld.vercel.app/',
			repoLink:'https://github.com/KhaleequeurRehman/nextjsDashboardApp',
		},
		{
			name:'Crypto.com',
			description:'It is a clone of crypto.com. It has screens e.g: crypto.com Landing Page, Nft Marketplace, Drops, Top Collections, Create, etc, it is created using Nextjs 13',
			tag:'Project',
			imgSrc:'/work/cryptodotcomNftMarketplace.png',
			hostLink:'https://cryptoclone.vercel.app/nft/marketplace',
			repoLink:'https://cryptoclone.vercel.app/',
		},
	]


	return (
		<>
			<h2 className="head-text">
				My Creative <span>Portfolio</span> Section
			</h2>

			<div className="app__work-filter">
				{["UI/UX", "Web App", "Mobile App", "React JS", "All"].map(
					(item, index) => {
						return (
							<div
								key={index}
								onClick={() => {
									handleWorkFilter(item);
								}}
								className={`app__work-filter-item app__flex p-text ${
									activeFilter === item ? "item-active" : ""
								}`}>
								{item}
							</div>
						);
					}
				)}
			</div>

			<motion.div
				animate={animateCard}
				transition={{ duration: 0.5, delayChildren: 0.5 }}
				className="app__work-portfolio">
				{/* {filterWork.map((work, index) => {
					return (
						<div className="app__work-item app__flex" key={index}>
							<div className="app__work-img app__flex">
								<img src={urlFor(work.imgUrl)} alt={work.name} />

								<motion.div
									whileHover={{ opacity: [0, 1] }}
									transition={{
										duration: 0.25,
										ease: "easeInOut",
										staggerChildren: 0.25,
									}}
									className="app__work-hover app__flex">
									<a href={work.projectLink} target="_blank" rel="noreferrer">
										<motion.div
											whileInView={{ scale: [0, 1] }}
											whileHover={{ scale: [1, 0.9] }}
											transition={{
												duration: 0.25,
											}}
											className="app__flex">
											<AiFillEye />
										</motion.div>
									</a>
									<a href={work.codeLink} target="_blank" rel="noreferrer">
										<motion.div
											whileInView={{ scale: [0, 1] }}
											whileHover={{ scale: [1, 0.9] }}
											transition={{
												duration: 0.25,
											}}
											className="app__flex">
											<AiFillGithub />
										</motion.div>
									</a>
								</motion.div>
							</div>

							<div className="app__work-content app__flex">
								<h4 className="bold-text">{work.title}</h4>
								<p className="p-text" style={{ marginTop: 10 }}>
									{work.description}
								</p>

								<div className="app__work-tag app__flex">
									<p className="p-text">{work.tags[0]}</p>
									<p className="p-text">{work.tags[1]}</p>
									<p className="p-text">{work.tags[2]}</p>
								</div>
							</div>
						</div>
					);
				})} */}


				{
					workData.map((item,index)=>(
						 <div className="app__work-item app__flex">
							<div className="app__work-img app__flex">
								<img src={item?.imgSrc} alt={item?.name} />

								<motion.div
									whileHover={{ opacity: [0, 1] }}
									transition={{
										duration: 0.25,
										ease: "easeInOut",
										staggerChildren: 0.25,
									}}
									className="app__work-hover app__flex">
									<a href={item?.hostLink} target="_blank" rel="noreferrer">
										<motion.div
											whileInView={{ scale: [0, 1] }}
											whileHover={{ scale: [1, 0.9] }}
											transition={{
												duration: 0.25,
											}}
											className="app__flex">
											<AiFillEye />
										</motion.div>
									</a>
									<a href={item?.repoLink} target="_blank" rel="noreferrer">
										<motion.div
											whileInView={{ scale: [0, 1] }}
											whileHover={{ scale: [1, 0.9] }}
											transition={{
												duration: 0.25,
											}}
											className="app__flex">
											<AiFillGithub />
										</motion.div>
									</a>
								</motion.div>
							</div>

							<div className="app__work-content app__flex">
								<h4 className="bold-text">{item?.name}</h4>
								<p className="p-text" style={{ marginTop: 10 }}>
									{item?.description}
								</p>

								<div className="app__work-tag app__flex">
									<p className="p-text">{item?.tag}</p>
								</div>
							</div>
						</div> 
					))
				}



				{/* <div className="app__work-item app__flex">
					<div className="app__work-img app__flex">
						<img src={"https://cdn.sanity.io/images/401mjdck/production/41c913ca45bfa3858451074312fe39941c1b3e1a-1331x625.png"} alt={"Admin Panel"} />

						<motion.div
							whileHover={{ opacity: [0, 1] }}
							transition={{
								duration: 0.25,
								ease: "easeInOut",
								staggerChildren: 0.25,
							}}
							className="app__work-hover app__flex">
							<a href={"https://adminpanel-reactapp.netlify.app/"} target="_blank" rel="noreferrer">
								<motion.div
									whileInView={{ scale: [0, 1] }}
									whileHover={{ scale: [1, 0.9] }}
									transition={{
										duration: 0.25,
									}}
									className="app__flex">
									<AiFillEye />
								</motion.div>
							</a>
							<a href={"https://github.com/jaffasunny/react-admin-panel"} target="_blank" rel="noreferrer">
								<motion.div
									whileInView={{ scale: [0, 1] }}
									whileHover={{ scale: [1, 0.9] }}
									transition={{
										duration: 0.25,
									}}
									className="app__flex">
									<AiFillGithub />
								</motion.div>
							</a>
						</motion.div>
					</div>

					<div className="app__work-content app__flex">
						<h4 className="bold-text">Admin Panel</h4>
						<p className="p-text" style={{ marginTop: 10 }}>
							Admin panel created with React using Material UI and Recharts
						</p>

						<div className="app__work-tag app__flex">
							<p className="p-text">{"abc"}</p>
							<p className="p-text">{"asd"}</p>
							<p className="p-text">{"fgh"}</p>
						</div>
					</div>
				</div> */}
			</motion.div>
		</>
	);
};

export default AppWrap(MotionWrap(Work, "app__works"), "work", "app__primarybg");
